var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookHandChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    fill: "#F4F4F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#DEDEDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 35.25H40.25V33.5H26.511C26.0875 33.4895 25.5833 33.3294 25.5833 32.625C25.5833 31.9206 26.0875 31.7605 26.511 31.75H40.25V19.5C40.25 18.5349 39.4278 17.75 38.4167 17.75H26.5C25.3945 17.75 23.75 18.4491 23.75 20.375V32.625C23.75 34.5509 25.3945 35.25 26.5 35.25ZM25.5833 23V20.375C25.5833 19.6706 26.0875 19.5105 26.5 19.5H38.4167V30H25.5833V23Z",
    fill: "#11B55F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 21.25H36.5833V23H28.3333V21.25Z",
    fill: "#11B55F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4225 37.4641C46.7874 36.851 45.7972 36.8911 45.1299 37.4641L40.1572 41.6979C39.5491 42.2193 38.7903 42.5 38.0046 42.5H31.6381C31.1645 42.5 30.777 42.0875 30.777 41.5833C30.777 41.0792 31.1645 40.6667 31.6381 40.6667H35.8519C36.7076 40.6667 37.5041 40.0422 37.644 39.1427C37.8216 37.9969 36.9928 37 35.9434 37H27.3328C25.8797 37 24.4751 37.5328 23.345 38.5068L20.8425 40.6667H17.8611C17.3875 40.6667 17 41.0792 17 41.5833V47.0833C17 47.5875 17.3875 48 17.8611 48H37.0628C37.8431 48 38.6019 47.7193 39.2154 47.1979L47.3525 40.2656C48.1705 39.5724 48.2351 38.2432 47.4225 37.4641Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookHandChat);
export default __webpack_public_path__ + "static/media/bookHandChat.95c4490241849124c684a239705ac3db.svg";
export { ForwardRef as ReactComponent };